import React from 'react';

const STEPS = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
const COLOR = '#1E3A8A';

export default function AgendaProgressBar({ value = 0, editable = false, onChange }) {
  return (
    <div className="space-y-2">
      <div className="relative w-full h-7 rounded-full overflow-hidden" style={{ backgroundColor: '#DBEAFE' }}>
        <div
          className="absolute inset-y-0 left-0 rounded-full transition-all duration-300"
          style={{ width: `${value}%`, backgroundColor: COLOR }}
        />
        <div className="absolute inset-0 flex items-center justify-center text-xs font-bold text-white">
          {value}%
        </div>
      </div>
      {editable && (
        <div className="flex flex-wrap gap-1">
          {STEPS.map(s => (
            <button
              key={s}
              type="button"
              onClick={() => onChange(s)}
              className="px-2 py-1 rounded text-xs font-medium transition-colors"
              style={value === s
                ? { backgroundColor: COLOR, color: '#fff' }
                : { backgroundColor: '#EEF2FF', color: '#1E3A8A' }
              }
            >
              {s}%
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export function AgendaProgressBarVertical({ value = 0 }) {
  return (
    <div className="flex flex-col items-center gap-1" title={`${value}% concluído`}>
      <div className="relative w-3 h-10 rounded-full overflow-hidden" style={{ backgroundColor: '#DBEAFE' }}>
        <div
          className="absolute bottom-0 left-0 w-full rounded-full transition-all duration-300"
          style={{ height: `${value}%`, backgroundColor: COLOR }}
        />
      </div>
      <span className="text-[10px]" style={{ color: '#1E3A8A' }}>{value}%</span>
    </div>
  );
}
